import './i18n.reducer';
import * as selectors from './i18n.selectors';

export {
	selectors
};
